/* WEAVEPLACE Mobile MegaMenu v2.7 — isolate navigation buttons from Dawn MenuDrawer handlers. */
(() => {
  const init = (menu) => {
    if (menu.dataset.wpBound === '1') return;
    menu.dataset.wpBound = '1';
    const drawer = menu.closest('header-drawer');
    const rootDetails = drawer?.querySelector('#Details-menu-drawer-container');
    const panels = [...menu.querySelectorAll('[data-wp-panel]')];
    const findPanel = (id) => panels.find(panel => panel.dataset.wpPanel === id);

    const switchTo = (id, reverse = false) => {
      const next = findPanel(id);
      if (!next) return;
      const current = menu.querySelector('.wp-mm__panel.is-current');
      if (current === next) return;
      panels.forEach(panel => {
        panel.classList.remove('is-current', 'is-previous');
        panel.toggleAttribute('inert', panel !== next);
        panel.setAttribute('aria-hidden', panel === next ? 'false' : 'true');
      });
      if (current && !reverse) current.classList.add('is-previous');
      next.classList.add('is-current');
      next.scrollTop = 0;
      // Keep focus inside the drawer after making the old panel inert.
      const focusTarget = next.querySelector('[data-wp-back], [data-wp-open], a[href], button:not([disabled])');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    };

    // CAPTURE: Dawn's MenuDrawer constructor attaches a close handler to every
    // button in the drawer. Intercept only our navigation controls before that
    // target-level handler runs. Ordinary links and the hamburger are untouched.
    menu.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-wp-open], [data-wp-back]');
      if (!trigger || !menu.contains(trigger)) return;
      let target = trigger.getAttribute('data-wp-open') || trigger.getAttribute('data-wp-back');
      const goingBack = trigger.hasAttribute('data-wp-back');
      // Shop's children are rendered directly on the root menu in v2.6.
      // Their Liquid breadcrumb still points to p-Shop (legacy 3-level hierarchy),
      // so return directly to root when that child is opened from root.
      if (goingBack) {
        const current = menu.querySelector('.wp-mm__panel.is-current');
        const currentId = current?.dataset.wpPanel;
        const rootPanel = findPanel('root');
        const isRootChild = currentId && [...rootPanel?.querySelectorAll('[data-wp-open]') || []]
          .some(control => control.getAttribute('data-wp-open') === currentId);
        if (isRootChild) target = 'root';
      }
      if (!findPanel(target)) return;
      event.preventDefault();
      event.stopPropagation();
      switchTo(target, goingBack);
    }, true);

    // Instant hand-off: close the navigation and open the existing search in
    // the same user gesture. The drawer is visually hidden immediately, while
    // HeaderDrawer retains its normal 400ms cleanup and scroll restoration.
    const launchSearch = menu.closest('.menu-drawer')?.querySelector('.wp-mm__search-launch');
    if (launchSearch && rootDetails) {
      let handingOff = false;
      launchSearch.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (handingOff) return;
        const nativeSearch = document.querySelector('.section-header .header__icons details-modal.wp-header-search .wp-search-trigger')
          || document.querySelector('.section-header details-modal.wp-header-search .wp-search-trigger');
        if (!nativeSearch) return;
        handingOff = true;
        const header = drawer.closest('.section-header');
        // Hide the closing drawer before activating search to avoid a flash or
        // two competing modal layers; do not bypass the native close handler.
        header?.classList.add('wp-mm-search-handoff');
        const summary = rootDetails.querySelector(':scope > summary');
        if (rootDetails.open && summary) summary.click();
        // No timeout and no waiting for the 400ms close transition.
        nativeSearch.click();
        window.setTimeout(() => {
          header?.classList.remove('wp-mm-search-handoff');
          handingOff = false;
        }, 480);
      }, true);
    }

    if (rootDetails) {
      new MutationObserver(() => {
        if (!rootDetails.open) switchTo('root', true);
      }).observe(rootDetails, { attributes: true, attributeFilter: ['open'] });
    }
  };
  const boot = () => document.querySelectorAll('[data-wp-mobile-menu]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
